import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'
import { Group, Property } from '@app/shared/models/common-models'
import { PropertyChangeArgs } from '@app/shared/models/entity-update.model'
import { EntityService } from '@app/shared/services/entity.service'

@Component({
  selector: 'app-property-group',
  templateUrl: './property-group.component.html',
  styleUrls: ['./property-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PropertyGroupComponent {
  @Input() group: Group

  @Input() formGroup: UntypedFormGroup

  @Input() isExpansionGroup: boolean

  @Input() isExpanded: boolean

  @Output() propertyChange = new EventEmitter<PropertyChangeArgs>()

  constructor(private entityService: EntityService) {}

  onPropertyChange(event: PropertyChangeArgs): void {
    this.propertyChange.emit(event)
  }

  propertyTrackBy = (index: number, property: Property): string => {
    return property.Key
  }

  filterProperties = (property: Property): boolean => {
    return property.IsVisible
  }

  isLong = (property: Property): boolean => {
    const longPropertyMetadata = this.entityService.getMetadata(property, 'LongProperty')
    return longPropertyMetadata != null
  }

  isRadioButton = (property: Property): boolean => {
    const radioButtonMetadata = this.entityService.getMetadata(property, 'isRadioButton')
    return radioButtonMetadata != null
  }
}
